import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-ForwardBack",
  "use": "svg-icon-ForwardBack-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol viewBox=\"0 0 12 12\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svg-icon-ForwardBack\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.905 2.89a.505.505 0 0 0-.797 0L2.45 5.549a.5.5 0 0 0 .707.708l1.84-1.84V9.21a.5.5 0 1 0 1 0V4.396l1.859 1.86a.5.5 0 1 0 .707-.708L5.905 2.891z\" /><path d=\"M5 9h3.5a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5V9z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol